<template>
  <!-- Small centered column -->
  <b-col offset-lg="3" lg="6" class="spacer-top-big">
    <!-- Form -->
    <b-form>
      <!-- Card -->
      <b-card
        class="card-small"
        header-tag="h3"
        header="Item Detail">
        <!-- Card Body -->
        <b-row class="pb-3">
          <b-col lg='3'><strong>{{ $t("TestItems.title") }}:</strong></b-col>
          <b-col lg='9'>{{Item.title}}</b-col>
        </b-row>
        <b-row>
          <b-col lg='3'><strong>{{ $t("TestItems.description") }}:</strong></b-col>
          <b-col lg='9'>{{Item.description}}</b-col>
        </b-row>
        <!-- Card Body END -->
        <!-- Card Footer -->
        <div
          slot="footer"
          class="text-right">
          <!-- <b-btn data-trackname="itemsDetailCancel" @click="cancel" variant="link">
            Cancel
          </b-btn> -->
          <!-- <b-btn data-trackname="itemsDetailEdit" @click="edit" variant="primary">
            Edit <i class="fa fa-edit"></i>
          </b-btn> -->
          <b-btn data-trackname="itemDetailDelete"
               v-if="Item.id"
               @click="delete_item"
               variant="danger">
               {{ $t("TestItems.delete") }}
               <i class="fa fa-trash"></i>
          </b-btn>
        </div>
        <!-- Card Footer END -->
      </b-card>
      <!-- Main Card END -->
    </b-form>
    <!-- Form END -->
  </b-col>
  <!-- Small centered column END -->
</template>

<script>
export default {
  name: 'TestItems',
  data () {
    return {
      Item: {
        id: '',
        title: '',
        description: ''
      }
    };
  },
  i18n: {
    messages: {
      en: {
        TestItems: {
          title: 'Title',
          description: 'Description',
          delete: 'Delete'
        }
      },
      es: {
        TestItems: {
          title: 'Título',
          description: 'Descripción',
          delete: 'Borrar'
        }
      }
    }
  },
  methods: {
    delete_item () {
      this.$http.delete('testitems/' + this.Item.id + '/').then(response => {
        if (response.ok) {
          this.$router.push({ name: 'Home' });
        }
      });
    },
    edit () {
      this.$router.push({ name: 'TestItemEdit', params: { id: this.Item.id } });
    },
    cancel () {
      this.$router.push({ name: 'TestItemList' });
    }
  },
  mounted () {
    window.scrollTo(0, 0);
    this.$http.get('testitems/' + this.$route.params.id).then(response => {
      this.Item = response.data;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Index/ItemDetail.vue